/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import update from 'immutability-helper';

import { PersistAppReduxActions } from './Action';

export const persistAppState: PersistApplicationState = {
    rowsPerPage: {
        dashboard: 0,
        managePacket: 0,
        history: 10,
        checklist: 10,
        access: 10,
    },
    tabId: '',
    isReload: false,
    idx: 0,
    previousIdx: 0,
    recordLocations: [],
};

const PersistAppStateReducer = (
    state = persistAppState,
    action: any = { type: '', payload: {} }
): PersistApplicationState => {
    switch (action.type) {
        case PersistAppReduxActions.PERSIST_LOCATION_CHANGE:
            // eslint-disable-next-line no-case-declarations
            const { location, action: actionLocation } = (action.payload ||
                {}) as {
                location?: any | null;
                action?: any | null;
            };

            return update(state, {
                recordLocations: {
                    $splice: [[0, 0, { location, action: actionLocation }]],
                },
            });
        case PersistAppReduxActions.PERSIST_APP_SET_PACKET_ROWSPERPAGE:
            return update(state, {
                rowsPerPage: {
                    $merge: {
                        managePacket: action.payload,
                    },
                },
            });
        case PersistAppReduxActions.PERSIST_APP_SET_HISTORY_ROWSPERPAGE:
            return update(state, {
                rowsPerPage: {
                    $merge: {
                        history: action.payload,
                    },
                },
            });
        case PersistAppReduxActions.PERSIST_APP_SET_ACCESS_ROWSPERPAGE:
            return update(state, {
                rowsPerPage: {
                    $merge: {
                        access: action.payload,
                    },
                },
            });
        case PersistAppReduxActions.PERSIST_APP_SET_CHECKLIST_ROWSPERPAGE:
            return update(state, {
                rowsPerPage: {
                    $merge: {
                        checklist: action.payload,
                    },
                },
            });
        case PersistAppReduxActions.PERSIST_APP_IDX:
            return update(state, {
                $merge: {
                    idx: action.payload,
                },
            });
        case PersistAppReduxActions.PERSIST_APP_PREVIOUSLY_IDX:
            return update(state, {
                $merge: {
                    previousIdx: action.payload,
                },
            });
        case PersistAppReduxActions.PERSIST_APP_SET_RELOAD:
            return update(state, {
                $merge: {
                    isReload: action.payload,
                },
            });
        case PersistAppReduxActions.PERSIST_APP_TABID:
            return update(state, {
                $merge: {
                    tabId: action.payload,
                },
            });
        default:
            return state;
    }
};

export default PersistAppStateReducer;
